import { render, staticRenderFns } from "./LandingBenefits.vue?vue&type=template&id=4375feef&scoped=true"
import script from "./LandingBenefits.vue?vue&type=script&lang=js"
export * from "./LandingBenefits.vue?vue&type=script&lang=js"
import style0 from "./LandingBenefits.vue?vue&type=style&index=0&id=4375feef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4375feef",
  null
  
)

export default component.exports